<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav></sbnb-gx-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0">Questions</h2>
      </sbnb-page-header>
      <h2>Questions</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'gx-questions'"></sbnb-helptext-wrapper>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'gx-questions'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
      <sbnb-filter
        #filterComponent
        *ngIf="segmentFilterDefaults"
        fxFlex
        componentName="questions"
        [hideSaveSegment]="true"
        [defaultFilters]="segmentFilterDefaults"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>
      <span *ngIf="!segmentFilterDefaults" fxFlex></span>
      <sbnb-search-bar
        placeholderText="Search..."
        [initialVal]="searchCriteria"
        (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
      <!-- <button
        type="submit"
        mat-flat-button
        class="button__small button__add-new"
        (click)="openCreateDialog()"
      >
        + Add new
      </button> -->
    </div>

    <div *ngIf="loading" class="table__no-items">Loading questions...</div>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="(!loading && !intents) || intents?.length === 0"
        icon="question"
        text="No questions found matching these filters"></sbnb-no-items>

      <div *ngIf="intents && intents.length > 0" class="rules__container">
        <div fxLayout fxLayoutGap="19px" fxHide.lt-md class="rules__rule-header">
          <div fxFlex>Question name</div>
          <div fxFlex>Definition</div>
          <div fxFlex>Related rules</div>
        </div>

        <a
          *ngFor="let intent of intents"
          fxLayout
          class="rules__rule-container"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="16px"
          [routerLink]="['/gx/questions/intent/' + intent.uuid]">
          <div fxFlex fxLayout fxLayoutGap="16px">
            <span class="rule__title ellipsis">{{ intent.name }}</span>
          </div>

          <div fxFlex>
            <span class="text__small" fxHide.lt-md>Detect questions about "{{ intent.name }}"</span>
          </div>

          <div fxFlex fxHide.lt-md fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
            <span *ngIf="intent.related_rulesets.length === 0" class="text__small rules__none">None</span>
            <span *ngIf="intent.related_rulesets.length > 0" fxHide.lt-md class="text__small rules__rule">
              {{ intent.related_rulesets[0].name }}
            </span>
            <span *ngIf="intent.related_rulesets.length > 1" class="text__small rules__count">
              +{{ intent.related_rulesets.length - 1 }}
            </span>
          </div>

          <div fxFlex fxHide fxShow.lt-md fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
            <span *ngIf="intent.related_rulesets.length === 0" class="text__small rules__none">No rules</span>
            <span *ngIf="intent.related_rulesets.length > 1" class="text__small rules__count">
              +{{ intent.related_rulesets.length }} rules
            </span>
          </div>
        </a>
      </div>
    </ng-container>

    <sbnb-pagination
      *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
      position="end"
      [pageCount]="paginationData.page_numbers.total_pages"
      [currentPage]="paginationData.page_numbers.this_page"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
